import React from "react";
import { Box, Tooltip } from "@mui/material";
import { useStockComparisonSnapshot } from "../Charts/hooks/useStockComparisonSnapshot";
import ComparisonStockPanel from "./ComparisonStockPanel";
import SearchBar from "../../common/SearchBar/SearchBar";

interface ComparisonSlotProps {
  ticker: string | null;
  color: string;
  placeholder?: string;
  onSelect: (ticker: string) => void;
  onClear: () => void;
  disabled?: boolean;
}

const ComparisonSlot = ({ ticker, color, placeholder, onSelect, onClear, disabled }: ComparisonSlotProps) => {
  const { data: snapshot } = useStockComparisonSnapshot(ticker);

  if (!ticker || !snapshot) {
    return (
      <Box sx={{ height: "100%", display: "flex", alignItems: "center", px: 2, width: "100%" }}>
        <Tooltip title={disabled ? "Available with Insight Pro" : ""} arrow>
          <span style={{ display: "block", width: "100%" }}>
            <SearchBar
              placeholder={placeholder ?? "Search for a stock..."}
              variant="compact"
              width="100%"
              onSelectItem={(result) => onSelect(result.symbol)}
              disabled={disabled}
            />
          </span>
        </Tooltip>
      </Box>
    );
  }

  return <ComparisonStockPanel snapshot={snapshot} color={color} onClear={onClear} />;
};

export default ComparisonSlot;
